import { render, staticRenderFns } from "./EditPortalContent.vue?vue&type=template&id=1619caf3&"
import script from "./EditPortalContent.vue?vue&type=script&lang=js&"
export * from "./EditPortalContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports